import { Button, Paper, Stack, Typography } from '@mui/material'
import loginWallpaper from '../../images/login_wallpaper.jpg'
import NoEncryptionIcon from '@mui/icons-material/NoEncryption'
import RefreshIcon from '@mui/icons-material/Refresh'
import ImageLogoDefault from '../../images/Logo.PNG'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

/**
 * Document object
 * @param {Object} props Props object
 * @param {('VALID'|'INVALID'|'EXPIRED'|'NOT_FOUND'|'NO_CONNECTION'|'WRONG_SIGNATURE'|'INVALID_DATE'|'MAX_MACHINE_REACH'|'MISMATCH_LICENSE')} props.licenseStatus License status
 */
const NoLicense = ({ licenseStatus }) => {
  const { t_ } = useSmartTranslation()

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      backgroundImage: `url(${loginWallpaper})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    logo: {
      width: '300px',
      marginBottom: '20px',
      objectFit: 'contain'
    }
  }

  const getLicenseStatusDescription = () => {
    if (licenseStatus === null) {
      return t_('Could not connect with MIC server')
    }
    switch (licenseStatus) {
      case 'INVALID':
        return t_('License invalid')
      case 'EXPIRED':
        return t_('License expired')
      case 'NOT_FOUND':
        return t_('License not found')
      case 'NO_CONNECTION':
        return t_('No connection to license server')
      case 'WRONG_SIGNATURE':
        return t_('Wrong license signature')
      case 'INVALID_DATE':
        return t_('Invalid date on license')
      case 'MAX_MACHINE_REACH':
        return t_('Maximum number of machines reached on this license')
      case 'MISMATCH_LICENSE':
        return t_('Mismatch license found')
      default:
        return ''
    }
  }

  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div style={styles.container}>
      <Paper sx={{ background: (theme) => theme.palette.background.paper, borderRadius: '10px' }}>
        <Stack gap={3} alignItems='center' direction='column' sx={{ margin: '3rem' }}>
          <img src={ImageLogoDefault} height='100px' alt='SmartPM logo' style={styles.logo} onError={(e) => { e.target.src = ImageLogoDefault }} />
          <NoEncryptionIcon sx={{ fontSize: 60 }} color='error' />
          <Typography color='error' sx={{ fontSize: '2rem' }}>{getLicenseStatusDescription()}</Typography>
          <Button
            variant='contained'
            startIcon={<RefreshIcon />}
            onClick={handleRefresh}
          >
            {t_('Refresh')}
          </Button>
        </Stack>
      </Paper>
    </div>
  )
}

export default NoLicense
